const ENTER_KEYS = new Set(["Enter"]);
const SPACE_KEYS = new Set([" ", "Spacebar"]);

function isButtonLikeElement(element) {
  if (!element || !element.tagName) return false;
  const tag = element.tagName.toLowerCase();
  if (tag === "button") return true;
  if (element.getAttribute && element.getAttribute("role") === "button") return true;
  if (element.classList && element.classList.contains("btn")) return true;
  return false;
}

function isTextEntryElement(element) {
  if (!element || !element.tagName) return false;
  const tag = element.tagName.toLowerCase();
  if (tag === "textarea") return true;
  if (element.isContentEditable) return true;
  return false;
}

function shouldBlockKeyRepeat(event) {
  if (!event.repeat) return false;

  const key = event.key;
  const isEnter = ENTER_KEYS.has(key);
  const isSpace = SPACE_KEYS.has(key);
  if (!isEnter && !isSpace) return false;

  const target = event.target;
  if (isTextEntryElement(target)) return false;

  if (isSpace && !isButtonLikeElement(target)) return false;

  return true;
}

function onKeyDown(event) {
  if (!shouldBlockKeyRepeat(event)) return;
  event.preventDefault();
  event.stopPropagation();
}

let installed = false;

/**
 * Prevents held Enter/Space key auto-repeat from firing repeated button clicks or form submits.
 * First keydown (event.repeat === false) is unaffected.
 */
export function installKeyRepeatGuard() {
  if (installed || typeof document === "undefined") return;
  document.addEventListener("keydown", onKeyDown, true);
  installed = true;
}
